// Vendors
import { cookies } from '@openbank/cf-ui-architecture-core';
// Constants
import { WEBSOCKET_SEND_MESSAGE_CONFIGURATION } from './constants/websocket.handlers.utils.constants';
// Enumerations
import { StorageCookiesEnum } from '@openbank/ziniaweb-ui-core-models';
import { WebSocketSendBuilderHandlersType } from 'handlers/types/websocket.handlers.type';

const getLendingWebsocketUrl = (): string =>
  `${window.WEBSOCKET_DOMAIN_URL}?accessToken=${cookies.getCookie(
    StorageCookiesEnum.ACCESS_TOKEN
  )}`;

const createWebSocketMessagePayload = ({
  payload,
  endpoint,
}: Omit<WebSocketSendBuilderHandlersType, 'websocketRef'>): string =>
  JSON.stringify({
    ...WEBSOCKET_SEND_MESSAGE_CONFIGURATION,
    endpoint,
    details: {
      payload,
      headers: {
        accessToken: cookies.getCookie(StorageCookiesEnum.ACCESS_TOKEN),
      },
    },
  });

export { createWebSocketMessagePayload, getLendingWebsocketUrl };
